import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

// items: [{label, to}] — last item is current page (no link)
export const Breadcrumb = ({ items }) => (
  <nav aria-label="Fil d'Ariane" className="w-full" data-testid="breadcrumb">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs sm:text-sm text-chrome-mid">
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-chrome-dark" />}
            {last ? (
              <span className="text-white/90 font-medium" aria-current="page">{it.label}</span>
            ) : (
              <Link to={it.to} className="hover:text-signature transition-colors">{it.label}</Link>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
